export { default as Img200 } from './processed/200/trekking.jpg';
export { default as Img400 } from './processed/400/trekking.jpg';
export { default as Img600 } from './processed/600/trekking.jpg';
export { default as Imgthumb } from './processed/thumb/trekking.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/trekking.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/trekking.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      206,
      32,
      66
    ],
    "_population": 133,
    "_hsl": [
      0.9674329501915708,
      0.7310924369747899,
      0.4666666666666667
    ]
  },
  "LightVibrant": {
    "_rgb": [
      239,
      111,
      135
    ],
    "_population": 2233,
    "_hsl": [
      0.96875,
      0.8,
      0.6862745098039216
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      107,
      11,
      38
    ],
    "_population": 198,
    "_hsl": [
      0.953125,
      0.8135593220338982,
      0.23137254901960785
    ]
  },
  "Muted": {
    "_rgb": [
      149,
      164,
      90
    ],
    "_population": 1370,
    "_hsl": [
      0.20045045045045043,
      0.2913385826771654,
      0.4980392156862745
    ]
  },
  "LightMuted": {
    "_rgb": [
      219,
      211,
      185
    ],
    "_population": 436,
    "_hsl": [
      0.12745098039215685,
      0.320754716981132,
      0.792156862745098
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      47,
      40
    ],
    "_population": 2437,
    "_hsl": [
      0.02592592592592594,
      0.36,
      0.24509803921568626
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/trekking.js